/**
 * Адреса контрактов токенов DEX-площадок (dexsol_spot / dexbsc_spot /
 * dexbase_spot / dexegld_spot / dexada_spot / dexavax_spot / dexsui_spot / dexnear_spot) — для ссылки с ноги на страницу обмена. Грузятся один раз по
 * первому запросу ссылки; пока не пришли — ссылка на DexScreener сети.
 */
import { apiClient } from '../api/client';

type Tokens = Record<string, Record<string, string>>;
let cache: Tokens | null = null;
let loading = false;

const QUOTE: Record<string, string> = {
  dexbsc_spot: '0x55d398326f99059fF775485246999027B3197955',   // USDT BEP20
  dexbase_spot: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',  // USDC Base
  dexegld_spot: 'USDC-c76f1f',                                 // USDC MultiversX
  dexavax_spot: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E',  // USDC Avalanche
  dexsui_spot: '0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC',  // USDC Sui
};
const DS_CHAIN: Record<string, string> = {
  dexsol_spot: 'solana', dexbsc_spot: 'bsc', dexbase_spot: 'base',
  dexegld_spot: 'multiversx', dexada_spot: 'cardano', dexavax_spot: 'avalanche', dexsui_spot: 'sui', dexnear_spot: 'near',
};

export const isDexVenue = (ex: string): boolean => ex.toLowerCase() in DS_CHAIN;

export function dexSwapUrl(ex: string, base: string): string {
  const v = ex.toLowerCase();
  if (!cache && !loading) {
    loading = true;
    apiClient.raw.get('/api/dex/tokens')
      .then(r => { cache = r.data || {}; })
      .catch(() => { /* останется ссылка на DexScreener */ })
      .finally(() => { loading = false; });
  }
  const addr = cache?.[v]?.[base.toUpperCase()];
  if (!addr) return `https://dexscreener.com/${DS_CHAIN[v] || ''}`;
  if (v === 'dexsol_spot') return `https://jup.ag/swap/USDC-${addr}`;
  if (v === 'dexbsc_spot') {
    return `https://pancakeswap.finance/swap?chain=bsc&inputCurrency=${QUOTE[v]}&outputCurrency=${addr}`;
  }
  if (v === 'dexegld_spot') {
    // Родная монета сети на xExchange — «EGLD», а не обёртка WEGLD.
    const tok = base.toUpperCase() === 'EGLD' ? 'EGLD' : addr;
    return `https://xexchange.com/swap?firstToken=${QUOTE[v]}&secondToken=${tok}`;
  }
  if (v === 'dexada_spot') return `https://app.dexhunter.io/swap?tokenIdSell=&tokenIdBuy=${addr}`;
  if (v === 'dexavax_spot') return `https://kyberswap.com/swap/avalanche/${QUOTE[v]}-to-${addr}`;
  if (v === 'dexsui_spot') return `https://app.cetus.zone/swap/?from=${QUOTE[v]}&to=${addr}`;
  if (v === 'dexnear_spot') return `https://app.rhea.finance/#wrap.near|${addr}`;
  return `https://app.uniswap.org/swap?chain=base&inputCurrency=${QUOTE[v]}&outputCurrency=${addr}`;
}
